module.exports = __webpack_public_path__ + "img/home_63.a9d93287.svg";